<template>
  <div class="m-wrap m-wap wap-verify-logo">
    <Logo :extras="extras" />
    <Banner :extras="extras" />
    <!--<div class="logo">-->
    <!--<img src="../../assets/images/wap/logo.png" alt="" />-->
    <!--</div>-->
    <!--<div class="banner">-->
    <!--<img src="../../assets/images/wap/banner.png" alt="" />-->
    <!--</div>-->
    <div class="verify-content">
      <div class="verify">
        <div
          class="tab-text"
          :style="{
            fontSize: pxOrVw(extraItem.extras('loginfont.size')),
            fontWeight: extraItem.extras('loginfont.weight'),
          }"
        >
          {{ extras | extra("loginfont.model") }}
        </div>
        <!--字段上下结构-->
        <div v-if="extraItem.extras('formfield.model') == 'style1-wap'">
          <div class="tab-input">
            <div class="must style1-wap">
              <div class="u-label">
                {{ identityPlaceholder || identityPlaceholderDefault }}
              </div>
              <a-input
                v-model="identity"
                class="verify-input"
                :class="{ err: error.identityText }"
                :placeholder="identityPlaceholder || identityPlaceholderDefault"
              ></a-input>
              <div
                v-if="isShowPhoneTips"
                style="color: #cacaca; font-size: 3.2vw; margin-top: 1vw"
              >
                手机号请填写区号，如86
              </div>
              <div class="u-reg-err-tips">{{ error.identityText }}</div>
            </div>
          </div>
          <div
            class="tab-input"
            :style="{
              display:
                extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
            }"
          >
            <div class="must style1-wap">
              <div class="u-label">验证码</div>
              <div class="verify-con">
                <a-input
                  class="verify-input"
                  v-model="code"
                  :class="{ err: error.codeText }"
                  placeholder="验证码"
                ></a-input>
                <a-button
                  class="verify-a"
                  type="primary"
                  @click="sendCode()"
                  :disabled="isRunning"
                  >{{
                    isRunning ? initialNum + "s以后重新发送" : "发送验证码"
                  }}</a-button
                >
              </div>

              <div class="u-reg-err-tips">{{ error.codeText }}</div>
            </div>
          </div>
        </div>

        <!--字段内嵌结构-->
        <div v-if="extraItem.extras('formfield.model') == 'style2-wap'">
          <div class="tab-input">
            <div class="must style2-wap">
              <div class="m-input-content">
                <div class="opacityText">
                  {{ identityPlaceholder || identityPlaceholderDefault }}
                </div>
                <a-input
                  v-model="identity"
                  class="verify-input status-input"
                  :class="{ err: error.identityText }"
                ></a-input>
                <div class="u-label" :class="{ moved: identity }">
                  {{ identityPlaceholder || identityPlaceholderDefault }}
                </div>
              </div>
              <div
                v-if="isShowPhoneTips"
                style="color: #cacaca; font-size: 3.2vw; margin-top: 1vw"
              >
                手机号请填写区号，如86
              </div>
              <div class="u-reg-err-tips">{{ error.identityText }}</div>
            </div>
          </div>
          <div
            class="tab-input"
            :style="{
              display:
                extraItem.extras('verifySet.display') == 0 ? 'none' : 'block',
            }"
          >
            <div class="must style2-wap">
              <div class="m-input-content">
                <div class="opacityText">验证码</div>
                <a-input
                  class="verify-input status-input"
                  v-model="code"
                  :class="{ err: error.codeText }"
                ></a-input>
                <div class="u-label" :class="{ moved: code }">验证码</div>
                <a
                  class="verify-a"
                  type="primary"
                  @click="sendCode()"
                  :disabled="isRunning"
                  >{{
                    isRunning ? initialNum + "s以后重新发送" : "发送验证码"
                  }}</a
                >
              </div>

              <div class="u-reg-err-tips pull-absolute">
                {{ error.codeText }}
              </div>
            </div>
          </div>
        </div>

        <a-button
          class="verify-submit ant-btn-primary-default"
          @click="submitVerify()"
          :style="{
            backgroundColor:
              extraItem.extras('themecolor.bgcolor') === '#1665D8' &&
              extraItem.extras('loginsubmitfont.bgcolor')
                ? extraItem.extras('loginsubmitfont.bgcolor')
                : extraItem.extras('themecolor.bgcolor'),
            color: extraItem.extras('loginsubmitfont.color'),
          }"
          >{{ extras | extra("loginsubmitfont.model") }}</a-button
        >
        <div
          class="verify-tip"
          :style="{
            display:
              extraItem.extras('signSet.display') == 0 ? 'none' : 'block',
          }"
        >
          <span class="">尚未报名？</span>
          <a
            :href="$router.resolve(signUp).href"
            class="u-text-blue"
            :style="{
              color: extraItem.extras('themecolor.bgcolor')
                ? extraItem.extras('themecolor.bgcolor')
                : '#1665D8',
            }"
            >点击报名</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Logo from "@/components/Logo.vue";
import Banner from "@/components/Banner.vue";
import mixinConfig from "../../mixin/config.js";
import mixin from "../../mixin/form.js";
import mixinVerify from "../../mixin/verify.js";
export default {
  name: "WapVerify",
  mixins: [mixinConfig, mixin, mixinVerify],
  data() {
    return {
      platform: "wap",
    };
  },
  components: {
    Logo,
    Banner,
  },
};
</script>
